<canvas #canvas class="chart-canvas"></canvas>
